<i18n>
{
  "fr": {
    "Export": "Exporter en Excel",
    "Title": "Rapport de Pull Requests de"
  }
}
</i18n>

<template>
  <section>
    <AppHeader :title="$t('Title') + ' ' + getUserById($route.query.user).user.displayName">
      <div class="row justify-content-end">
        <div class="col-auto">
          <ButtonExport
            :label="$t('Export')"
            @click="exportToExcel()"/>
        </div>
      </div>
    </AppHeader>
    <AppContainer>
      <BaseTabs slot="left">
        <BaseTab
          :to="{
            name: 'PullRequest-Global',
            query: $route.query
          }"
          label="Global"/>
        <BaseTab
          v-for="projectPullRequests in filteredProjectsPullRequests"
          :key="projectPullRequests.projectName"
          :to="{
            name: 'PullRequest-Details',
            params: { projectName: projectPullRequests.projectName },
            query: $route.query
          }"
          :label="$t(projectPullRequests.projectName)" />
      </BaseTabs>
      <router-view :key="$route.fullPath" />
    </AppContainer>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState('pullRequests', ['projectsPullRequests']),
    ...mapGetters('users', ['getUserById']),
    filteredProjectsPullRequests() {
      return this.projectsPullRequests.filter(x => x.rejectedPullRequestCount > 0);
    },
  },
  created() {
    this.$store.dispatch('pullRequests/getListByProject', this.$route.query);
  },
  methods: {
    exportToExcel() {
      this.$store.dispatch('pullRequests/exportToExcel');
    },
  },
};
</script>
